import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { GetDashboardData } from 'domain/usecases/get-dashboard-data';
import { RemoteGetDashboardData } from 'data/usecases/remote-get-dashboard';

export const makeRemoteGetDashboard = (): GetDashboardData => {
  return new RemoteGetDashboardData(makeApiUrl('/getDashboard'), makeAuthorizeHttpClientDecorator());
};
